import { Multiselect } from '@dreryk/react-components';
import { createTranslatedText, FormContextValues } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { usePatientGroupLabelExtractor } from './PatientGroupsAssignmentsMultiselect.hooks';
import { PatientGroup } from './PatientGroupsAssignmentsMultiselect.types';

const PATIENT_GROUP_FIELD_NAME = 'patientGroups';

export type PatientGroupsAssignmentsMultiselectFormBeanPart = { [PATIENT_GROUP_FIELD_NAME]: PatientGroup[] };

type PatientGroupsAssignmentsMultiselectProps = Pick<
   FormContextValues<PatientGroupsAssignmentsMultiselectFormBeanPart>,
   'register'
> & {
   patientGroups: PatientGroup[];
};

export const PatientGroupsAssignmentsMultiselect = (props: PatientGroupsAssignmentsMultiselectProps): JSX.Element => {
   return (
      <Multiselect<PatientGroup>
         testId={PATIENT_GROUP_FIELD_NAME}
         width={'274px'}
         label={translationKeys.patientGroups}
         triggerLabelExtractor={usePatientGroupLabelExtractor(props.patientGroups.length)}
         placeholder={translationKeys.selectGroups}
         controller={props.register(PATIENT_GROUP_FIELD_NAME)}
         itemKeyGenerator={'id'}
      >
         <Multiselect.List<PatientGroup> items={props.patientGroups} keyExtractor={'id'}>
            {(group) => (
               <Multiselect.Item
                  item={group}
                  label={<Multiselect.Highlight node={createTranslatedText(group.name)} />}
                  testId={group.id}
               />
            )}
         </Multiselect.List>
      </Multiselect>
   );
};
